import { Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { SessionData, CourseAnalyticsTab } from "@shared/services/analytics.service";
@Component({
    selector: 'latest-sessions-widget',
    template: `
    <table *ngIf="sessions" class="latest-sessions-table">
        <tr *ngFor="let session of sessions">
            <td class="row-content"> <mat-icon>account_circle</mat-icon><span class="title">{{ formatActor(session.actor_name) }} - {{ getRelativeDate(session.date) }}</span></td>
            <td class="row-link"> <span class="link" (click)="viewMore(session.actor_name)">Learn More</span> </td>
        </tr>
    </table>
  `,
    styles: [
        `
        .latest-sessions-table{
            width: 100%;
        }
        .row-content{
            display: flex;
            align: flex-start;
        }
        .row-content mat-icon{
            margin-right: 8px;
        }
        .row-content .title{
            display: inline-flex;
            align-items: center;
        }
        .row-link .link{
            width: 100%;
            text-align: end;
            text-decoration: underline;
            cursor: pointer;
            font-size: 12px;
        }
    `
    ]
})
export class LatestSessionsWidgetComponent implements OnInit {
    @Input() sessions: SessionData[];
    @Output() onSearch = new EventEmitter<{ name: string, tab?: CourseAnalyticsTab }>();
    constructor(
    ) {

    }
    ngOnInit(): void {
    }
    formatActor(name: string): string {
        if (name.indexOf('Anonymous') > -1) {
            return 'Anonymous';
        }
        return name;
    }
    getRelativeDate(date: Date): string {
        return moment(date).fromNow();
    }
    viewMore(userName: string) {
        this.onSearch.emit({ name: userName, tab: CourseAnalyticsTab.Sessions })
    }

}
